let Animations = {
    init: () => {
        handleWordAnimations();
        handleScrollAnimations();
    }
};

const handleWordAnimations = () => {
    $("[fade-in-words]").attr("fade-in-words", function(i, d){
        let $self  = $(this),
            $words = d.split("|"),
            $tot = $words.length,
            $c = 0;

        for (let i=0; i<$tot; i++) $self.append($('<span/>',{text:$words[i]}));

        $words = $self.find("span").hide();

        (function loop(){
            $self.animate({ width: $words.eq($c).width() });
            $words.stop().fadeOut().eq($c).fadeIn().delay(2000).show(0, loop);
            $c = ++$c % $tot;
        }());
    });
}

const handleScrollAnimations = () => {
    const observedElements = document.querySelectorAll('.animation-on-scroll');
    const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) entry.target.classList.add(entry.target.dataset.animation);
            });
        });

    observedElements.forEach(element => observer.observe(element));
}

export default Animations;
